export const menuItems = [
  [
    {
      _menuReference: 'Solutions',
      link: '',
      icon: './assets/images/icons/ntt_data/homepage/business_solutions/business_solutions.svg',
      title: 'Business Solution',
      required: ['BUSINESS SOLUTIONS', 'MEGAZORD_MENU_REDIS'],
      access: null,
      menuShortcuts: [
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/business_solutions/system_admin.svg',
          title: 'System Admin',
          required: ['BUSINESS SOLUTIONS', 'MEGAZORD_MENU_REDIS'],
          access: null,
          areas: [
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/business_solutions/system_setup.svg',
              title: 'System Setup',
              required: ['BUSINESS SOLUTIONS', 'MEGAZORD_MENU_REDIS'],
              access: null,
              child: [
                {
                  link: 'roles-setup',
                  icon: './assets/images/icons/ntt_data/homepage/business_solutions/roles.svg',
                  title: 'Roles',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: true
                },
                {
                  link: 'users-setup',
                  icon: './assets/images/icons/ntt_data/homepage/business_solutions/users.svg',
                  title: 'Users',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: true
                },
                {
                  link: 'teams-setup',
                  icon: './assets/images/icons/ntt_data/homepage/business_solutions/teams.svg',
                  title: 'Teams',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: true
                },
                {
                  link: 'menu-config',
                  icon: './assets/images/icons/ntt_data/homepage/business_solutions/menu_config.svg',
                  title: 'Menu Config',
                  required: ['MEGAZORD_MENU_REDIS'],
                  access: null,
                  liked: true
                }
              ]
            },
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/business_solutions/security_roles.svg',
              title: 'Security Roles',
              required: ['BUSINESS SOLUTIONS'],
              access: null,
              child: [
                {
                  link: 'am-setup',
                  icon: './assets/images/icons/ntt_data/homepage/business_solutions/account_manager.svg',
                  title: 'Account Manager',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: true
                }
              ]
            }
          ]
        }
      ]
    },
    {
      _menuReference: 'O2O',
      link: '',
      icon: './assets/images/icons/ntt_data/homepage/o2o/o2o.svg',
      title: 'O2O',
      required: [
        'SERVICE DELIVERY',
        'INTERNATIONAL',
        'VENDOR OPS',
        'PURCHASING',
        'SC OPS',
        'SALES',
        'BUSINESS SOLUTIONS',
        'RMA TEAM',
        'BACKLOG TEAM',
        'INSIDE SALES',
        'ORDER MANAGEMENT',
        'O2O OPS',
        'INTERNATIONAL CLIENT COORDINATOR'
      ],
      access: null,
      menuShortcuts: [
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/o2o/order_management.svg',
          title: 'Order Management',
          required: [
            'SERVICE DELIVERY',
            'INTERNATIONAL',
            'VENDOR OPS',
            'PURCHASING',
            'SC OPS',
            'SALES',
            'BUSINESS SOLUTIONS',
            'RMA TEAM',
            'BACKLOG TEAM',
            'INSIDE SALES',
            'ORDER MANAGEMENT',
            'O2O OPS',
            'INTERNATIONAL CLIENT COORDINATOR'
          ],
          access: null,
          areas: [
            {
              link: 's2p/portal-home',
              icon: './assets/images/icons/ntt_data/homepage/o2o/scout.svg',
              title: 'SCOUT',
              required: [
                'SERVICE DELIVERY',
                'INTERNATIONAL',
                'VENDOR OPS',
                'PURCHASING',
                'SC OPS',
                'SALES',
                'BUSINESS SOLUTIONS',
                'RMA TEAM',
                'BACKLOG TEAM',
                'INSIDE SALES',
                'ORDER MANAGEMENT',
                'O2O OPS',
                'INTERNATIONAL CLIENT COORDINATOR'
              ],
              access: null,
              liked: false
            }
          ]
        }
      ]
    },
    {
      _menuReference: 'Operations Portal',
      link: '',
      icon: './assets/images/icons/ntt_data/homepage/operations_portal/card_op_operations-portal.svg',
      title: 'Operations Portal',
      required: ['SC OPS', 'VENDOR OPS', 'SALES', 'PURCHASING', 'SERVICE DELIVERY', 'BUSINESS SOLUTIONS'],
      access: null,
      menuShortcuts: [
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/operations_portal/card_op_scout.svg',
          title: 'SCOUT Portal',
          required: ['BUSINESS SOLUTIONS'],
          access: null
        },
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/operations_portal/card_op_dashboard.svg',
          title: 'Dashboard',
          required: ['SC OPS', 'VENDOR OPS', 'SALES', 'PURCHASING', 'SERVICE DELIVERY', 'BUSINESS SOLUTIONS'],
          access: null,
          areas: [
            {
              link: 's2p/po-spending',
              icon: './assets/images/icons/ntt_data/homepage/operations_portal/card_op_po-spending.svg',
              title: 'PO Spending',
              required: ['SC OPS', 'VENDOR OPS', 'PURCHASING', 'BUSINESS SOLUTIONS'],
              access: null
            },
            {
              link: 's2p/aged-inventory',
              icon: './assets/images/icons/ntt_data/homepage/operations_portal/card_op_aged-inventory.svg',
              title: 'Aged Inventory',
              required: ['SC OPS', 'SALES', 'SERVICE DELIVERY', 'BUSINESS SOLUTIONS'],
              access: null
            },
            {
              link: 's2p/warehouse-throughput',
              icon: './assets/images/icons/ntt_data/homepage/operations_portal/card_op_throughput.svg',
              title: 'WH Throughput',
              required: ['SC OPS', 'BUSINESS SOLUTIONS'],
              access: null
            }
          ]
        }
      ]
    },
    {
      _menuReference: 'S2P',
      link: '',
      icon: './assets/images/icons/ntt_data/homepage/s2p/s2p.svg',
      title: 'S2P',
      required: [
        'SC OPS',
        'SALES',
        'SERVICE DELIVERY',
        'VENDOR OPS',
        'PURCHASING',
        'INTERNATIONAL',
        'RMA TEAM',
        'BACKLOG TEAM',
        'BUSINESS SOLUTIONS'
      ],
      access: null,
      menuShortcuts: [
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/s2p/warehouse_management.svg',
          title: 'Warehouse Management',
          required: ['SC OPS', 'SALES', 'SERVICE DELIVERY', 'BUSINESS SOLUTIONS'],
          access: null,
          areas: [
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/s2p/wm_dashboard.svg',
              title: 'Dashboard',
              required: ['SC OPS', 'SALES', 'SERVICE DELIVERY', 'BUSINESS SOLUTIONS'],
              access: null,
              child: [
                {
                  link: 's2p/provision-dashboard',
                  icon: './assets/images/icons/ntt_data/homepage/s2p/provision.svg',
                  title: 'Provision',
                  required: ['SC OPS', 'BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                }
              ]
            }
          ]
        },
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/s2p/procurement_management.svg',
          title: 'Procurement Management',
          required: ['VENDOR OPS', 'PURCHASING', 'SC OPS', 'BUSINESS SOLUTIONS'],
          access: null,
          areas: [
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/s2p/pm_dashboard.svg',
              title: 'Dashboard',
              required: ['VENDOR OPS', 'PURCHASING', 'SC OPS', 'BUSINESS SOLUTIONS'],
              access: null
            }
          ]
        },
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/s2p/sourcing_operations.svg',
          title: 'Sourcing Operations',
          required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
          access: null,
          areas: [
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_management.svg',
              title: 'Vendor Management',
              required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
              access: null,
              child: [
                {
                  link: '',
                  icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_setup.svg',
                  title: 'Vendor Setup',
                  required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false,
                  children: [
                    {
                      link: 'skills-management/skill-setup',
                      icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_skill_setup.svg',
                      title: 'Skill Setup',
                      required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                      access: null,
                      liked: false
                    },
                    {
                      link: 'services-management/service-setup',
                      icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_service_setup.svg',
                      title: 'Service Setup',
                      required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                      access: null,
                      liked: false
                    },
                    {
                      link: 'technologies-management/technology-setup',
                      icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_technology_setup.svg',
                      title: 'Technology Setup',
                      required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                      access: null,
                      liked: false
                    },
                    {
                      link: 'certifications-management/certification-setup',
                      icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_certification.svg',
                      title: 'Certification Setup',
                      required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                      access: null,
                      liked: false
                    },
                    {
                      link: 'vendors-management/vendor-setup',
                      icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_management_setup.svg',
                      title: 'Vendor Management Setup',
                      required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                      access: null,
                      liked: false
                    }
                  ]
                },
                {
                  link: 'vendors-management/vendor-dashboard',
                  icon: './assets/images/icons/ntt_data/homepage/s2p/vendor_dashboard.svg',
                  title: 'Vendor Dashboard',
                  required: ['VENDOR OPS', 'BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                }
              ]
            }
          ]
        },
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/s2p/operations_management.svg',
          title: 'Operations Management',
          required: ['RMA TEAM', 'BACKLOG TEAM', 'BUSINESS SOLUTIONS', 'RMA [REQUESTOR]'],
          access: null,
          areas: [
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/s2p/backlog.svg',
              title: 'Backlog',
              required: ['BACKLOG TEAM', 'BUSINESS SOLUTIONS'],
              access: null,
              child: [
                {
                  link: 'po-backlog-management',
                  icon: './assets/images/icons/ntt_data/homepage/s2p/backlog_management.svg',
                  title: 'Manage Your Request',
                  required: ['BACKLOG TEAM', 'BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                }
              ]
            },
            {
              link: '',
              icon: './assets/images/icons/homepage/task_automation/rma.svg',
              title: 'RMA',
              required: ['RMA TEAM', 'BUSINESS SOLUTIONS', 'RMA [REQUESTOR]'],
              access: null,
              child: [
                {
                  link: 'rma/management/table',
                  icon: './assets/images/icons/homepage/task_automation/rma_manage_your_tasks.svg',
                  title: 'Manage Your Tasks',
                  required: ['BUSINESS SOLUTIONS', 'RMA TEAM'],
                  access: null,
                  liked: false
                },
                {
                  link: 'rma/new-request',
                  icon: './assets/images/icons/homepage/task_automation/rma_new_request.svg',
                  title: 'Request a Task',
                  required: ['BUSINESS SOLUTIONS', 'RMA TEAM', 'RMA [REQUESTOR]'],
                  access: null,
                  liked: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      _menuReference: 'Global Services',
      link: '',
      icon: './assets/images/icons/ntt_data/homepage/global_services/global_services.svg',
      title: 'Global Services',
      required: ['BUSINESS SOLUTIONS'],
      access: null,
      menuShortcuts: [
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/global_services/task_management.svg',
          title: 'Task Management',
          required: ['BUSINESS SOLUTIONS'],
          access: null,
          areas: [
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/global_services/task_admin.svg',
              title: 'Admin',
              required: ['BUSINESS SOLUTIONS'],
              access: null,
              child: [
                {
                  link: 'task-management/priority-setup',
                  icon: './assets/images/icons/ntt_data/homepage/global_services/priority_setup.svg',
                  title: 'Priority Setup',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                },
                {
                  link: 'task-management/request-setup',
                  icon: './assets/images/icons/ntt_data/homepage/global_services/request_setup.svg',
                  title: 'Request Setup',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                }
              ]
            },
            {
              link: '',
              icon: './assets/images/icons/ntt_data/homepage/global_services/request_management.svg',
              title: 'Request Management',
              required: ['BUSINESS SOLUTIONS'],
              access: null,
              child: [
                {
                  link: 'task-management/center/request-new-task',
                  icon: './assets/images/icons/ntt_data/homepage/global_services/new_request.svg',
                  title: 'New Request',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                },
                {
                  link: 'task-management/center/manage-your-task',
                  icon: './assets/images/icons/ntt_data/homepage/global_services/request_management.svg',
                  title: 'Manage Your Request',
                  required: ['BUSINESS SOLUTIONS'],
                  access: null,
                  liked: false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      _menuReference: 'PAC40',
      link: '',
      icon: './assets/images/icons/ntt_data/homepage/pac40/card_pac40.svg',
      title: 'PAC40',
      required: ['BUSINESS SOLUTIONS', 'SALES TEST SUPER USER'],
      access: null,
      menuShortcuts: [
        {
          link: 'pac-forty/pac-forty-dashboard',
          icon: './assets/images/icons/ntt_data/homepage/pac40/card_pac40_dashboard.svg',
          title: 'PAC40 Management',
          required: ['BUSINESS SOLUTIONS', 'SALES TEST SUPER USER'],
          access: null
        },
        {
          link: '',
          icon: './assets/images/icons/ntt_data/homepage/pac40/card_pac40_admin.svg',
          title: 'Admin',
          required: ['BUSINESS SOLUTIONS', 'SALES TEST SUPER USER'],
          access: null,
          areas: [
            {
              link: 'pac40/configuration',
              icon: './assets/images/icons/ntt_data/homepage/pac40/card_pac40_sales_op.svg',
              title: 'Client GP Config',
              required: ['BUSINESS SOLUTIONS', 'SALES TEST SUPER USER'],
              access: null
            }
          ]
        }
      ]
    },
    {
      _menuReference: 'My Workspace',
      link: '',
      icon: '',
      title: 'My Workspace',
      required: [
        'SERVICE DELIVERY',
        'INTERNATIONAL',
        'VENDOR OPS',
        'PURCHASING',
        'SC OPS',
        'SALES',
        'BUSINESS SOLUTIONS',
        'RMA TEAM',
        'BACKLOG TEAM',
        'INSIDE SALES',
        'ORDER MANAGEMENT',
        'O2O OPS',
        'INTERNATIONAL CLIENT COORDINATOR',
        'RENEWALS',
        'SALES SUPPORT',
        'SERVICE MANAGER',
        'CLIENT MANAGER',
        'RMA [REQUESTOR]'
      ],
      access: null,
      menuShortcuts: [
        {
          link: 'my-workspace/my-profile',
          icon: '',
          title: 'My Workspace Page',
          required: [
            'SERVICE DELIVERY',
            'INTERNATIONAL',
            'VENDOR OPS',
            'PURCHASING',
            'SC OPS',
            'SALES',
            'BUSINESS SOLUTIONS',
            'RMA TEAM',
            'BACKLOG TEAM',
            'INSIDE SALES',
            'ORDER MANAGEMENT',
            'O2O OPS',
            'INTERNATIONAL CLIENT COORDINATOR',
            'RENEWALS',
            'SALES SUPPORT',
            'SERVICE MANAGER',
            'CLIENT MANAGER',
            'RMA [REQUESTOR]'
          ],
          access: null,
          liked: false
        },
        {
          link: 'my-workspace/service-center/new-request',
          icon: './assets/images/icons/homepage/new_request.svg',
          title: 'Request New Service',
          required: [
            'SERVICE DELIVERY',
            'INTERNATIONAL',
            'VENDOR OPS',
            'PURCHASING',
            'SC OPS',
            'SALES',
            'BUSINESS SOLUTIONS',
            'RMA TEAM',
            'BACKLOG TEAM',
            'INSIDE SALES',
            'ORDER MANAGEMENT',
            'O2O OPS',
            'INTERNATIONAL CLIENT COORDINATOR',
            'RENEWALS',
            'SALES SUPPORT',
            'SERVICE MANAGER',
            'CLIENT MANAGER',
            'RMA [REQUESTOR]'
          ],
          access: null,
          liked: false
        },
        {
          link: 'requests-management',
          icon: '',
          title: 'Manage Your Tasks',
          required: [
            'SERVICE DELIVERY',
            'INTERNATIONAL',
            'VENDOR OPS',
            'PURCHASING',
            'SC OPS',
            'SALES',
            'BUSINESS SOLUTIONS',
            'RMA TEAM',
            'BACKLOG TEAM',
            'INSIDE SALES',
            'ORDER MANAGEMENT',
            'O2O OPS',
            'INTERNATIONAL CLIENT COORDINATOR',
            'RENEWALS',
            'SALES SUPPORT',
            'SERVICE MANAGER',
            'CLIENT MANAGER',
            'RMA [REQUESTOR]'
          ],
          access: null,
          liked: false
        }
      ]
    },
    {
      _menuReference: 'Automation Intelligence',
      link: 'ts-project/home',
      icon: './assets/images/icons/ts-mgmt/automation-intelligence.svg',
      description: 'System automations to enhance efficiency, accuracy, and traceability.',
      required: ['MEGAZORD', 'BUSINESS SOLUTIONS', 'FINANCIAL', 'CLIENT MANAGER', 'PROJECT MANAGER'],
      access: null,
      items: [
        {
          title: 'Financial',
          link: 'ts-project/home',
          icon: './assets/images/icons/ts-mgmt/financial.svg',
          description: 'Centralized financial process automation for consistency and control.',
          required: ['MEGAZORD', 'BUSINESS SOLUTIONS', 'FINANCIAL', 'CLIENT MANAGER', 'PROJECT MANAGER'],
          access: null,
          items: [
            {
              title: 'TS Project Management',
              link: 'ts-project/table',
              icon: './assets/images/icons/ts-mgmt/ts-project-management.svg',
              description: 'Cost, revenue, and GL management for Technical Services projects.',
              required: ['MEGAZORD', 'BUSINESS SOLUTIONS', 'FINANCIAL', 'CLIENT MANAGER', 'PROJECT MANAGER'],
              access: null,
              liked: false
            }
          ]
        }
      ]
    }
  ]
];
